module.exports = __webpack_public_path__ + "img/logo_tinex.6849be6d.jpg";